import { descendantsOf, type Container } from "@egalregal/shared";
import { useAppStore } from "../../shared/store/app";

/**
 * Targets the Link picker must never offer (container-view 05): the current
 * container and everything below it. Linking the current container under one
 * of its own descendants would close a cycle, so the picker hides all of them.
 */
export function linkTargetExclusions(
  containers: readonly Container[],
  currentId: string,
): Set<string> {
  return new Set([currentId, ...descendantsOf(containers, currentId).map((c) => c.id)]);
}

/**
 * Link a container under the picked parent (container-view 05). The first id is
 * the parent, the second becomes its child — the inverse of the old detail-view
 * behaviour. The store refreshes the tree after the call, so both levels see
 * the move.
 */
export async function linkUnderParent(parentId: string, childId: string): Promise<void> {
  await useAppStore.getState().linkChild(parentId, childId);
}
